const KEY_NAME = 'smartagent-message-map';

const localStorage = (() => {
    let hasStoragePermissions = false;
    try {
        window.localStorage.getItem('');
        hasStoragePermissions = true;
    } catch (error) {
        hasStoragePermissions = false;
    }

    const getItem = (key: string) => hasStoragePermissions ? window.localStorage.getItem(key) : ""
    const setItem = (key: string, value: string) => hasStoragePermissions ? window.localStorage.setItem(key, value) : void 0;
    const removeItem = (key: string) => hasStoragePermissions ? window.localStorage.removeItem(key) : void 0

    return {
        getItem,
        setItem,
        removeItem
    }

})()

export const messageMap = () => {

    const map : Record<string, string> = JSON.parse(
        localStorage.getItem(KEY_NAME) || '{}'
    )

    const get = (msgId: string) => map[msgId];
    const set = (msgId: string, msg: string) => {
        map[msgId] = msg;
        localStorage.setItem(KEY_NAME, JSON.stringify(map))
    }
    const clear = () => localStorage.removeItem(KEY_NAME)

    return {
        get,
        set,
        clear
    }

}